export enum MarketingPageElementType {
  cardinteractive = 'card-interactive',
  videobutton = 'video-button',
  buttonprimary = 'button-primary',
  linkdropdown = 'link-dropdown',
  buttonsecondary = 'button-secondary',
  link = 'link',
  image = 'image',
  accordion = 'accordion'
}

export enum MarketingPageElementLocation {
  nav = 'nav',
  navsub = 'nav-sub',
  hero = 'hero',
  body = 'body',
  prefooter = 'prefooter',
  footer = 'footer'
}
